window.discovery = true;


/*!
 * swiped-events.js - v@version@
 * Pure JavaScript swipe events
 * https://github.com/john-doherty/swiped-events
 * @inspiration https://stackoverflow.com/questions/16348031/disable-scrolling-when-touch-moving-certain-element
 * @author John Doherty <www.johndoherty.info>
 * @license MIT
 */
(function (window, document) {
  "use strict";

  // patch CustomEvent to allow constructor creation (IE/Chrome)
  if (typeof window.CustomEvent !== "function") {
    window.CustomEvent = function (event, params) {
      params = params || {
        bubbles: false,
        cancelable: false,
        detail: undefined,
      };

      var evt = document.createEvent("CustomEvent");
      evt.initCustomEvent(
        event,
        params.bubbles,
        params.cancelable,
        params.detail
      );
      return evt;
    };

    window.CustomEvent.prototype = window.Event.prototype;
  }

  document.addEventListener("touchstart", handleTouchStart, false);
  document.addEventListener("touchmove", handleTouchMove, false);
  document.addEventListener("touchend", handleTouchEnd, false);
  

  var xDown = null;
  var yDown = null;
  var xDiff = null;
  var yDiff = null;
  var timeDown = null;
  var startEl = null;

  /**
   * Fires swiped event if swipe detected on touchend
   * @param {object} e - browser event object
   * @returns {void}
   */
  function handleTouchEnd(e) {
    // if the user released on a different target, cancel!
    if (startEl !== e.target) return;

    var swipeThreshold = parseInt(
      getNearestAttribute(startEl, "data-swipe-threshold", "20"),
      10
    ); // default 20 units
    var swipeUnit = getNearestAttribute(startEl, "data-swipe-unit", "px"); // default px
    var swipeTimeout = parseInt(
      getNearestAttribute(startEl, "data-swipe-timeout", "500"),
      10
    ); // default 500ms
    var timeDiff = Date.now() - timeDown;
    var eventType = "";
    var changedTouches = e.changedTouches || e.touches || [];

    if (swipeUnit === "vh") {
      swipeThreshold = Math.round(
        (swipeThreshold / 100) * document.documentElement.clientHeight
      ); // get percentage of viewport height in pixels
    }
    if (swipeUnit === "vw") {
      swipeThreshold = Math.round(
        (swipeThreshold / 100) * document.documentElement.clientWidth
      ); // get percentage of viewport height in pixels
    }

    if (Math.abs(xDiff) > Math.abs(yDiff)) {
      // most significant
      if (Math.abs(xDiff) > swipeThreshold && timeDiff < swipeTimeout) {
        if (xDiff > 0) {
          eventType = "swiped-left";
        } else {
          eventType = "swiped-right";
        }
      }
    } else if (Math.abs(yDiff) > swipeThreshold && timeDiff < swipeTimeout) {
      if (yDiff > 0) {
        eventType = "swiped-up";
      } else {
        eventType = "swiped-down";
      }
    }

    if (eventType !== "") {
      var eventData = {
        dir: eventType.replace(/swiped-/, ""),
        touchType: (changedTouches[0] || {}).touchType || "direct",
        xStart: parseInt(xDown, 10),
        xEnd: parseInt((changedTouches[0] || {}).clientX || -1, 10),
        yStart: parseInt(yDown, 10),
        yEnd: parseInt((changedTouches[0] || {}).clientY || -1, 10),
      };

      // fire `swiped` event event on the element that started the swipe
      startEl.dispatchEvent(
        new CustomEvent("swiped", {
          bubbles: true,
          cancelable: true,
          detail: eventData,
        })
      );

      // fire `swiped-dir` event on the element that started the swipe
      startEl.dispatchEvent(
        new CustomEvent(eventType, {
          bubbles: true,
          cancelable: true,
          detail: eventData,
        })
      );
    }

    // reset values
    xDown = null;
    yDown = null;
    timeDown = null;
  }

  /**
   * Records current location on touchstart event
   * @param {object} e - browser event object
   * @returns {void}
   */
  function handleTouchStart(e) {
    // if the element has data-swipe-ignore="true" we stop listening for swipe events
    if (e.target.getAttribute("data-swipe-ignore") === "true") return;

    startEl = e.target;

    timeDown = Date.now();
    xDown = e.touches[0].clientX;
    yDown = e.touches[0].clientY;
    xDiff = 0;
    yDiff = 0;
  }

  /**
   * Records location diff in px on touchmove event
   * @param {object} e - browser event object
   * @returns {void}
   */
  function handleTouchMove(e) {
    if (!xDown || !yDown) return;

    var xUp = e.touches[0].clientX;
    var yUp = e.touches[0].clientY;

    xDiff = xDown - xUp;
    yDiff = yDown - yUp;
  }

  /**
   * Gets attribute off HTML element or nearest parent
   * @param {object} el - HTML element to retrieve attribute from
   * @param {string} attributeName - name of the attribute
   * @param {any} defaultValue - default value to return if no match found
   * @returns {any} attribute value or defaultValue
   */
  function getNearestAttribute(el, attributeName, defaultValue) {
    // walk up the dom tree looking for attributeName
    while (el && el !== document.documentElement) {
      var attributeValue = el.getAttribute(attributeName);

      if (attributeValue) {
        return attributeValue;
      }

      el = el.parentNode;
    }

    return defaultValue;
  }
})(window, document);



class ATCHandler extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    new AddToCart(this.element);
  }
}

customElements.define("atc-handler", ATCHandler);

class VideoComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.options = JSON.parse(this.element.getAttribute("data-section-settings"));
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.initializeVariables();
    new AddToCart(this.element);

    this.setupHistory();
    this.loadInitialElements();
    this.bindEvents();

    if (this.options['videos'] === 'json') {
      this.runProcess();
      setTimeout(() => {
        this.checkLoaded();
      }, 3000);
    } else {
      this.createVideoList();
      this.checkLoaded();
    }
  }

  // Initialize component variables
  initializeVariables() {
    this.trueObserver = false;
    this.count = 0;
    this.swipeCounts = 0;
    this.first = true;
    this.firstClick = true;
    this.translateValue = 0;
    this.transitionEnded = true;
    this.isPaused = false;
    this.muted = true;
  }

  // Setup history properties
  setupHistory() {
    if (history.scrollRestoration) {
      history.scrollRestoration = "manual";
    }
  }

  // Load initial elements with a delay
  loadInitialElements() {
    setTimeout(() => {
      this.discoveryEl = document.querySelector(".Discovery--Wrapper");
      this.mute = document.querySelectorAll(".muteControl");
    }, 100);
  }

  // Bind event listeners
  bindEvents() {
    console.log('bind events');
    this.handlePlayPauseListener = this.handlePlayPause.bind(this);

    setTimeout(() => {
      this.mute.forEach((item) => {
        item.addEventListener("click", this.toggleMute.bind(this));
      });
    }, 100);

    this.delegateBody.on("swiped-up", this.swipedDown.bind(this));
    this.delegateBody.on("swiped-down", this.swipedUp.bind(this));
    this.delegateElement.on("touchstart", this.forcePlay.bind(this));
    this.delegateBody.on("click", "#swiperDown", this.swipedDownDesktop.bind(this));
    this.delegateBody.on("click", "#swiperUp", this.swipedUpDesktop.bind(this));

    this.element.addEventListener("mousedown", this.handleMouseDown.bind(this));
    this.element.addEventListener("mouseup", this.handleDesktopSwiper.bind(this));

    setTimeout(() => {
      this.discoveryEl.addEventListener("touchmove", this.preventScroll, { passive: false });
    }, 100);

    document.addEventListener("popupOpened", this.handlePopupOpened.bind(this));
    document.addEventListener("popupClear", this.handlePopupClosed.bind(this));
  }

  handleMouseDown(event) {
    this.startX = event.pageX;
    this.startY = event.pageY;
  }

  preventScroll(event) {
    event.preventDefault();
  }

  async runProcess() {
    try {
      const storedVideos = sessionStorage.getItem('videos_list');
      const storedTime = sessionStorage.getItem('when_saved');
      const today = new Date().toDateString();
      if (storedVideos && storedTime === today && !this.firstClick) {
        this.videoRandomList = JSON.parse(storedVideos);
        if (this.isExpired(this.videoRandomList[0].videoUrl)) {
          await this.addInitialVideos();
        }
      } else {
        await this.addInitialVideos();
      }
      this.startInit();
    } catch (error) {
      console.log(error);
    }
  }

  async addInitialVideos() {
      const clickedVideoUrlHQ = sessionStorage.getItem('clickedVideoUrlHQ');
    const clickedVideoUrl = sessionStorage.getItem('clickedVideoUrl');
    const clickedPreviewUrl = sessionStorage.getItem('clickedPreviewUrl');

    const response = await fetch('https://europe-west1-boxball-prod.cloudfunctions.net/content/upvoted/videoUrls?limit=10&random=1');
    const json = await response.json();
    let videos = json.videos;

    if (clickedVideoUrl && clickedPreviewUrl) {
      const newVideo = { videoUrlHQ: clickedVideoUrlHQ, videoUrl: clickedVideoUrl, previewUrl: clickedPreviewUrl };
      videos.unshift(newVideo);
    }

    sessionStorage.setItem('videos_list', JSON.stringify(videos));
    this.videoRandomList = videos;
    sessionStorage.setItem('when_saved', new Date().toDateString());
  }

  isExpired(videoUrl) {
    const expireTimestamp = this.extractExpireTime(videoUrl);
    if (!expireTimestamp) {
      return true;
    }
    return new Date() > new Date(expireTimestamp * 1000);
  }

  extractExpireTime(videoUrl) {
    const regex = /Expires=(\d+)/;
    const match = videoUrl.match(regex);
    return match && match.length > 1 ? parseInt(match[1], 10) : null;
  }

  handlePopupOpened(event) {


    document.querySelector('.VideoRatio').style.transform = 'translateY(0vh)';
    this.resetSwipeCounts();
    setTimeout(() => {
      this.runProcess(true);
    }, 100);
  }

  handlePopupClosed(){

    this.isPaused = false;
    if(!this.overlay){
      this.overlay = document.body.querySelector(".pauseOverlay");
    }
    this.overlay.classList.remove('visible');
    this.overlay.removeEventListener("click", this.handlePlayPauseListener);
  }

  resetSwipeCounts() {
    this.count = 0;
    this.swipeCounts = 0;
    this.first = true;
    this.translateValue = 0;
    this.transitionEnded = true;
    this.muted = true;
    this.isPaused = false;

    const unmutedControls = document.querySelectorAll('.unmutedControl');
    const mutedControls = document.querySelectorAll('.mutedControl');
   
    unmutedControls.forEach(control => control.setAttribute('aria-hidden', 'true'));
    mutedControls.forEach(control => control.setAttribute('aria-hidden', 'false'));
    if(!this.overlay){
      this.overlay = document.body.querySelector(".pauseOverlay");
    }
    this.overlay.classList.remove('visible');
    this.overlay.removeEventListener("click", this.handlePlayPauseListener);
    document.querySelector("#swiperUp").setAttribute('aria-disabled', 'true');
  }

  handleDesktopSwiper(event) {
    const diffX = Math.abs(event.pageX - this.startX);
    const diffY = Math.abs(event.pageY - this.startY);

    if (diffX < 6 && diffY < 6) {
      this.handlePlayPause();
    } else if (diffY > this.startY) {
      this.swipedUpDesktop();
    } else {
      this.swipedDownDesktop();
    }
  }

  forcePlay() {
    console.log('play');
    setTimeout(() => {
      if (this.element.getAttribute('data-paused') === "true") return;
      const videoPlayingId = this.element.querySelector('.videoHolder[aria-visible="true"]').dataset.id;
      const videoPlaying = videojs(`#${videoPlayingId}`);
      videoPlaying.play();
    }, 100);
  }

  swipedUpDesktop() {
    if (!this.transitionEnded) return;

    const targetElement = document.querySelector('.videoHolder[aria-visible="true"]');
    if (this.canSwipeUp(targetElement)) {
      this.translateValue += 100;
      this.handleSwipeTransition(targetElement, 'previousSibling');

    }

    this.handlePostSwipeActions();
  }

  swipedDownDesktop() {

    if (!this.transitionEnded) return;

    const targetElement = document.querySelector('.videoHolder[aria-visible="true"]');

    if (this.canSwipeDown(targetElement)) {
      this.translateValue -= 100;
      this.handleSwipeTransition(targetElement, 'nextSibling');


    }

    this.handlePostSwipeActions();
  }

  canSwipeUp(targetElement) {
    return targetElement.previousSibling &&
      targetElement.previousSibling.classList.contains("videoHolder");
  }

  canSwipeDown(targetElement) {
    return targetElement.nextSibling &&
      targetElement.nextSibling.classList.contains("videoHolder");
  }

  simulateTouchStart() {
    const touchStartEvent = new TouchEvent('touchstart', {
      bubbles: true,
      cancelable: true,
      view: window,
      touches: [new Touch({
        identifier: Date.now(),
        target: document.querySelector('#videoPopup'),
        clientX: 0,
        clientY: 0,
        radiusX: 2.5,
        radiusY: 2.5,
        rotationAngle: 10,
        force: 0.5,
      })],
      targetTouches: [],
      changedTouches: []
    });
    const interactiveElement = document.querySelector('body');
    interactiveElement.dispatchEvent(touchStartEvent);
  }

  handleSwipeTransition(targetElement, direction) {

    this.swipeCounts += direction === 'nextSibling' ? 1 : -1;
    targetElement.removeAttribute("aria-visible");
    targetElement[direction].setAttribute("aria-visible", true);
    this.transitionEnded = false;

    if(this.swipeCounts == 0){
      document.querySelector("#swiperUp").setAttribute('aria-disabled', 'true');
    } else {
      document.querySelector("#swiperUp").setAttribute('aria-disabled', 'false');
    }

    this.element.closest(".VideoRatio").style.transform = `translateY(${this.translateValue}vh)`;

  }

  handlePostSwipeActions() {
    setTimeout(() => {
      this.transitionEnded = true;
      this.checkMute();
      this.simulateTouchStart();
    }, 400);

    setTimeout(() => {
      if(!document.querySelector('.videoHolder[aria-visible="true"]').nextSibling) return;
      const previewUrl = document.querySelector('.videoHolder[aria-visible="true"]').nextSibling.getAttribute('data-preview');
      const fakeVideo = document.querySelector("#backgroundVideo");
      fakeVideo.src = previewUrl;
    }, 200);

  }

  swipedUp(event) {
    if (!this.transitionEnded) return;

    const targetElement = document.querySelector('.videoHolder[aria-visible="true"]');
    if (this.canSwipeUp(event.target.closest(".videoHolder"))) {
      this.translateValue += 100;
      this.handleSwipeTransition(targetElement, 'previousSibling');

    }

    this.handlePostSwipeActions();
  }

  swipedDown(event) {
    if (!this.transitionEnded) return;

    const targetElement = document.querySelector('.videoHolder[aria-visible="true"]');
    if (this.canSwipeDown(event.target.closest(".videoHolder"))) {
      this.translateValue -= 100;
      this.handleSwipeTransition(targetElement, 'nextSibling');

    }

    this.handlePostSwipeActions();
  }

  checkLoaded() {
    if (typeof videojs !== "undefined") {
      this.startInit();
    } else {
      setTimeout(() => {
        this.checkLoaded();
      }, 100);
    }
  }

  startInit() {

    this.videoPlayerInitialization(this.count);
    this.count++;
  }

  toggleMute(event) {
    event.preventDefault();
    event.stopPropagation();
    const videoPlayingId = this.element.querySelector('.videoHolder[aria-visible="true"]').dataset.id;
    const videoPlaying = videojs(`#${videoPlayingId}`);

    if (videoPlaying.muted()) {
      this.unmuteVideo(videoPlaying, event);
    } else {
      this.muteVideo(videoPlaying, event);
    }
  }

  unmuteVideo(videoPlaying, event) {
    document.querySelectorAll('video').forEach(video => {
      console.log(video.id, videoPlaying.tagAttributes.id);
      const myVideoid = video.id.replace('_html5_api','');
      if(myVideoid !== videoPlaying.tagAttributes.id){
        videojs(video).pause();
      }

    });

    videoPlaying.muted(false);
    event.target.querySelector(".unmutedControl").setAttribute("aria-hidden", "false");
    event.target.querySelector(".mutedControl").setAttribute("aria-hidden", "true");
    this.muted = false;
    this.hideMuteControls();
  }

  muteVideo(videoPlaying, event) {
    videoPlaying.muted(true);
    event.target.querySelector(".unmutedControl").setAttribute("aria-hidden", "true");
    event.target.querySelector(".mutedControl").setAttribute("aria-hidden", "false");
    this.muted = true;
  }

  hideMuteControls() {
    this.mute.forEach((item) => {
      item.classList.add('hideMute');
    });
  }

  checkMute() {
    const videoHolders = this.element.querySelectorAll('.videoHolder');
    videoHolders.forEach(videoHolder => {
      const videoPlayer = videojs(`#${videoHolder.dataset.id}`);
      if (videoHolder.getAttribute('aria-visible') === 'true') {
        if (videoPlayer.muted() && !this.muted) {
          this.unmuteCurrentVideo(videoPlayer);
        } else if (!videoPlayer.muted() && this.muted) {
          this.muteCurrentVideo(videoPlayer);
        }
      } else {
        videoPlayer.muted(true);
      }
    });
  }

  unmuteCurrentVideo(videoPlayer) {
    document.querySelector(".unmutedControl").setAttribute("aria-hidden", "false");
    document.querySelector(".mutedControl").setAttribute("aria-hidden", "true");
    videoPlayer.muted(false);
    videoPlayer.play();
  }

  muteCurrentVideo(videoPlayer) {
    document.querySelector(".unmutedControl").setAttribute("aria-hidden", "true");
    document.querySelector(".mutedControl").setAttribute("aria-hidden", "false");
    videoPlayer.muted(true);
    this.hideMuteControls();
  }

  shuffle(array) {
    let currentIndex = array.length, randomIndex;
    while (currentIndex !== 0) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;
      [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
    }
    return array;
  }

  createVideoList() {
    this.videoList = JSON.parse(this.element.getAttribute("data-list"));

    if (this.options["randomize"] === "between_list") {
      this.videoRandomList = this.shuffle(this.flattenVideoList(this.videoList));
    } else if (this.options["randomize"] === "inside_list") {
      this.videoRandomList = this.shuffleInsideList(this.videoList);
    } else {
      this.videoRandomList = this.flattenVideoList(this.videoList);
    }
  }

  flattenVideoList(videoList) {
    let array = [];
    for (const key in videoList) {
      for (const key1 in videoList[key]) {
        array.push(videoList[key][key1]);
      }
    }
    return array;
  }

  shuffleInsideList(videoList) {
    let obj = {};
    for (const key in videoList) {
      obj[key] = this.shuffle([...videoList[key]]);
    }
    return this.flattenVideoList(obj);
  }

  videoPlayerInitialization(count) {
    let url = '';
    let description = '';
    let previewUrl = '';
    console.log('count', count);
    console.log( this.videoRandomList[count]);
    if (this.options['videos'] === 'json') {
      url = this.videoRandomList[count].videoUrlHQ + "#t=3.9";
      previewUrl = this.videoRandomList[count].previewUrl;
    } else {
      console.log('else');
      url = this.videoRandomList[count].video_id + "#t=3.9";
      description = this.videoRandomList[count].description;
    }

    const id = `my-player-${this.idGenerator()}`;
    const node = this.createVideoNode(id, url, previewUrl, description);
    if (!node) return;
    if (this.first) {
      this.initializeFirstVideo(node, count);
    }

    this.element.appendChild(node.firstElementChild).focus();
    this.element.setAttribute("loaded", true);

    this.setupVideoPlayer(id, url, count);
  }

  createVideoNode(id, url, previewUrl, description) {

    const node = document.createElement("div");
    if(!this.element.querySelector("template").content.firstElementChild.cloneNode(true)) {return}
    node.appendChild(this.element.querySelector("template").content.firstElementChild.cloneNode(true));
    node.querySelector("video").setAttribute("id", id);
    node.querySelector(".videoHolder").setAttribute("data-id", id);
    node.querySelector(".videoHolder").setAttribute("data-url", url);
    node.querySelector(".videoHolder").setAttribute("data-preview", previewUrl);

    if (description) {
      node.querySelector(".videoHolder--Quote").innerHTML = description;
    } else {
      node.querySelector(".videoHolder--Quote").style.display = 'none';
    }
    return node;
  }

  initializeFirstVideo(node, count) {
    node.querySelector(".videoHolder").setAttribute("aria-visible", true);
    const fakeVideo = document.querySelector("#backgroundVideo");
    if (fakeVideo) {
      fakeVideo.src = this.videoRandomList[count].previewUrl;
      this.first = false;
    }
  }

  setupVideoPlayer(id, url) {

    const payload = this.createVideoPayload(url);
    const videoplayerID = this.element.querySelector(`#${id}`);
    const videoHolder = videoplayerID.closest(".videoHolder");
    this.videoPlayer = [];
    this.videoPlayer[id] = videojs(videoplayerID, payload);
    this.videoPlayer[id].on("ready", () => {
      const holder = this.element.querySelector(`[data-id="${id}"]`);
      holder.style.display = "block";
      if(document.querySelector('.discover__load--overlay')){
        document.querySelector('.discover__load--overlay').setAttribute('aria-hidden', 'true');
      }
      if (this.options["pause"]) {
        requestAnimationFrame(() => {
            this.createObserver(id, videoHolder);
        });
    }
  });
  }

  createVideoPayload(url) {
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) || $(window).width() < 1025;
    const aspect_ratio = isMobile ? this.options["aspect_mob"] || "9:16" : this.options["aspect_desk"] || "16:9";
    const img_plh = isMobile ? this.options["plh_mob"] : this.options["plh_desk"];

    return {
      aspectRatio: aspect_ratio,
      autoplay: false,
      muted: this.options["muted"],
      loop: this.options["loop"],
      controls: this.options["controls"],
      poster: img_plh,
      preload: "metadata",
      playsinline: true,
      responsive: true,
      techOrder: ["html5"],
      disablePictureInPicture: true,
      controlBar: {
        playToggle: true,
        captionsButton: false,
        chaptersButton: false,
        subtitlesButton: false,
        remainingTimeDisplay: true,
        pictureInPictureToggle: false,
        volumeControl: false,
        progressControl: { seekBar: false },
        fullscreenToggle: true,
        playbackRateMenuButton: false,
      },
      sources: [{ type: "video/mp4", src: url }],
    };
  }

  handlePlayPause() {
    console.log('handle play pause', this.isPaused);
    this.overlay = document.body.querySelector(".pauseOverlay");
      const playingVideo = document.querySelector('.videoHolder[aria-visible="true"]').dataset.id;

      if (this.isPaused) {
        videojs(`#${playingVideo}`).play();
        this.element.setAttribute('data-paused', false);
        this.overlay.classList.remove("visible");
        this.overlay.removeEventListener("click", this.handlePlayPauseListener);
        document.querySelector('#swiperUp').classList.remove('hideControls');
        document.querySelector('#swiperDown').classList.remove('hideControls');
        this.isPaused = false;
      } else {
        console.log(playingVideo);
        videojs(`#${playingVideo}`).pause();

        this.element.setAttribute('data-paused', true);
        this.overlay.classList.add("visible");
        this.overlay.addEventListener("click", this.handlePlayPauseListener);
        this.mute.forEach((item) => {
          item.classList.remove('hideMute');
        });
        document.querySelector('#swiperUp').classList.add('hideControls');
        document.querySelector('#swiperDown').classList.add('hideControls');
        this.isPaused = true;
        console.log(this.isPaused);
      }
    
  }

  idGenerator() {
    return [...Array(10)].map(() => "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".charAt(Math.floor(Math.random() * 62))).join('');
  }

  createObserver(id, element) {

    const observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      rootMargin: "0px",
      threshold: 0.7,
    });
    observer.observe(element);
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      const playerID = entry.target.getAttribute("data-id");
      const videoPlayer = videojs(`#${playerID}`);
      if (entry.isIntersecting) {
        this.handleVideoIntersection(entry, playerID);
      } else {
        videoPlayer.pause();
      }
    });
  }

  handleVideoIntersection(entry, playerID) {
    const videoHolder = entry.target.closest(".videoHolder");
    if (!videoHolder.nextSibling || !videoHolder.nextSibling.classList.contains("videoHolder")) {
      this.videoPlayerInitialization(this.count);
      this.count = this.videoRandomList[this.count + 1] ? this.count + 1 : 0;
    }

    if (this.videoRandomList.length - 5 === this.count) {
      this.addAdditionalVideos();
    }

    videojs(`#${playerID}`).play();
    this.overlay = document.body.querySelector(".pauseOverlay");
                this.overlay.classList.remove("visible");
  }

  async addAdditionalVideos() {
    try {
      const response = await fetch('https://europe-west1-boxball-prod.cloudfunctions.net/content/upvoted/videoUrls?limit=50&random=1');
      const json = await response.json();
      const newVideos = json.videos;

      newVideos.forEach(video => {
        if (!this.videoRandomList.find(v => v.id === video.id)) {
          this.videoRandomList.push(video);
        }
      });

      sessionStorage.setItem('videos_list', JSON.stringify(this.videoRandomList));
    } catch (error) {
      console.log(error);
    }
  }
}

customElements.define("video-component", VideoComponent);






class pdpDiscovery extends HTMLElement {
  constructor() {
      super();
      this.element = this;
      this.delegateElement = new Delegate(this.element);

      this.getOnlineUsers();
      this.getVideos();

      // Check if the content is already prefetched globally, if not prefetch it
      if (!window.pdpPrefetchedContent) {
          this.prefetchContent();
      }
  }

  // Fetches the online users count and updates the elements with class 'onlineUsers'
  async getOnlineUsers() {
      const url = 'https://europe-west1-boxball-prod.cloudfunctions.net/appStatus';

      try {
          const response = await fetch(url);
          if (!response.ok) throw new Error('HTTP request failed');

          const data = await response.json();
          const onlineCnt = data.onlineCnt;
          this.updateOnlineUsers(onlineCnt);

      } catch (error) {
          console.error('Error during HTTP request:', error);
      }
  }

  // Updates the elements with the online user count
  updateOnlineUsers(onlineCnt) {
      const onlineUsersList = this.element.querySelectorAll('.onlineUsers');
      onlineUsersList.forEach(onlineUsers => {
          onlineUsers.innerHTML = onlineCnt;
      });
  }

  // Prefetches the content for the popup
  async prefetchContent() {
      let page = this.element.querySelector('.page_pdp').getAttribute('data-url');
      try {
          const response = await fetch(page);
          const html = await response.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          const targetSection = doc.querySelector('.Discovery--Wrapper').closest('.shopify-section');
          if (targetSection) {
              window.pdpPrefetchedContent = targetSection.innerHTML;
          } else {
              console.error('Section not found during prefetching.');
          }
      } catch (error) {
          console.error('Error fetching page content during prefetching:', error);
      }
  }

  // Opens a popup and fetches and displays video content
  async openPopup() {
      const popupElement = document.querySelector('#videoPopup');
      document.body.style.overflow = 'hidden';
      if (popupElement) {
          popupElement.style.display = "block";

          const videos = await this.getUpdatedVideoList();
          this.element.dispatchEvent(new CustomEvent('popupOpened', {
              bubbles: true,
              detail: { video_list: videos }
          }));
          return;
      }


      document.body.style.overflowY = 'hidden';

      if (window.pdpPrefetchedContent) {
          this.createPopup(window.pdpPrefetchedContent);
      } else {
          console.error('Prefetched content is not available.');
      }
  }

  // Creates the popup with the given content
  createPopup(content) {
      const popup = document.createElement('div');
      popup.id = 'videoPopup';
      popup.classList.add('popup');
      popup.style.display = "block";

      const contentWrapper = document.createElement('div');
      contentWrapper.classList.add('content-wrapper');
      contentWrapper.innerHTML = content;

      const closeButton = document.createElement('button');
      closeButton.classList.add('close');
      closeButton.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M24.9428 7.05715C25.4635 7.57785 25.4635 8.42207 24.9428 8.94277L8.94277 24.9428C8.42207 25.4635 7.57785 25.4635 7.05715 24.9428C6.53645 24.4221 6.53645 23.5779 7.05715 23.0572L23.0572 7.05715C23.5779 6.53645 24.4221 6.53645 24.9428 7.05715Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M7.05715 7.05715C6.53645 7.57785 6.53645 8.42207 7.05715 8.94277L23.0572 24.9428C23.5779 25.4635 24.4221 25.4635 24.9428 24.9428C25.4635 24.4221 25.4635 23.5779 24.9428 23.0572L8.94277 7.05715C8.42207 6.53645 7.57785 6.53645 7.05715 7.05715Z" fill="white"/></svg>';
      contentWrapper.appendChild(closeButton);

      popup.appendChild(contentWrapper);
      document.body.prepend(popup);

      this.addPopupEventListeners(popup);
  }

  // Adds event listeners to the popup for video playback and closing the popup
  addPopupEventListeners(popup) {
      popup.addEventListener('click', (event) => {
          if (event.target.classList.contains('close')) {
              this.closePopup(popup);
          } else {

              this.playVideos();
          }
      });

      document.addEventListener('popupClosed', () => this.closePopup(popup));
  }

  // Plays videos in the popup
  playVideos() {

      const videos = this.element.querySelectorAll('video');
      videos.forEach(video => {
          if (video.paused) {
              video.play().catch(error => {
                  console.error('Error playing video:', error);
              });
          }
      });
  }

  // Closes the popup and cleans up
  closePopup(popup) {
      const videoContainer = popup.querySelector('.content-wrapper');
      videoContainer.querySelectorAll('.videoHolder').forEach(video => video.remove());
      popup.style.display = "none";
      document.body.style.overflow = 'unset';
      document.querySelectorAll('video').forEach(video => video.play());
      document.body.removeAttribute('style');
      if(document.querySelector('.discover__load--overlay')){
        document.querySelector('.discover__load--overlay').setAttribute('aria-hidden', 'false');
      }
      console.log('close popup');
      this.element.dispatchEvent(new CustomEvent('popupClear', {
        bubbles: true
    }));
  }

  // Fetches an updated list of videos and updates the session storage
  async getUpdatedVideoList() {
          const clickedVideoUrlHQ = sessionStorage.getItem('clickedVideoUrlHQ');
      const clickedVideoUrl = sessionStorage.getItem('clickedVideoUrl');
      const clickedPreviewUrl = sessionStorage.getItem('clickedPreviewUrl');

      const response = await fetch('https://europe-west1-boxball-prod.cloudfunctions.net/content/upvoted/videoUrls?limit=10&random=1');
      const json = await response.json();
      let videos = json.videos;

      if (clickedVideoUrl && clickedPreviewUrl) {
  const newVideo = { videoUrlHQ: clickedVideoUrlHQ, videoUrl: clickedVideoUrl, previewUrl: clickedPreviewUrl };
          videos = [newVideo, ...videos.filter(video => video.videoUrl !== clickedVideoUrl)];
      }

      sessionStorage.setItem('videos_list', JSON.stringify(videos));
      sessionStorage.setItem('when_saved', new Date().toDateString());

      return videos;
  }

  // Fetches videos and initializes video players
  async getVideos() {
      
      const limit = parseInt(this.element.dataset.videos);

      try {
          const response = await fetch(`https://europe-west1-boxball-prod.cloudfunctions.net/content/upvoted/videoUrls?limit=${limit}&random=1`);
          const json = await response.json();
          const videos = json.videos;

          sessionStorage.setItem('circle_videos_list', JSON.stringify(videos));

          this.loadVideos(videos); // Load videos after fetching is complete
          window.onload = () => this.loadVideos(videos);
          window.addEventListener('beforeunload', () => this.loadVideos(videos));
          window.openPopup = (videoUrl) => this.openPopup(videoUrl);
      } catch (error) {
          console.error('Error fetching videos:', error);
      }
  }

  // Loads videos and sets up video players on the page
  loadVideos(videos) {
      const discoveryVideo = this.element.querySelector('.pdp_discoverVideos');
      if (videos && videos.length > 0) {
          videos.forEach((video, index) => {

              const elementToSwap = discoveryVideo.querySelector(`.circledVideo[data-position="${index + 1}"]`);

              const videoHolder = document.createElement('div');
              videoHolder.dataset.id = `video-${index}`;
              if(discoveryVideo.querySelector(`.videoHolder[data-id="video-${index}"]`)) { return }
              videoHolder.classList.add('videoHolder', 'is-hidden');

              elementToSwap.appendChild(videoHolder);

              this.createVideoPlayer(video.videoUrl, video.previewUrl, videoHolder);
          });
      } else {
          console.log('No videos found.');
      }
  }

  // Creates a video player using Video.js library
  createVideoPlayer(videoUrl, previewUrl, videoHolder) {

      const videoOptions = {
          controls: false,
          autoplay: true,
          muted: true,
          preload: "metadata",
          playsinline: true,
          responsive: true,
          sources: [{ src: videoUrl, type: 'video/mp4' }]
      };

      const videoElement = document.createElement('video');
      videoElement.classList.add('video-js');
      videoHolder.appendChild(videoElement);

      const player = videojs(videoElement, videoOptions);

      player.ready(() => {
          player.currentTime(3.9);
          const image = videoHolder.parentElement.querySelector('img');
          if(image){
            image.classList.add('is-hidden');
            videoHolder.classList.remove('is-hidden');
            setTimeout(() => image.remove(), 300);
          } else {
            videoHolder.classList.remove('is-hidden');
          }

      });

      player.on('timeupdate', () => {
          if (player.currentTime() >= 9) {
              player.currentTime(3.9);
              player.play();
          }
      });

      player.on('click', () => {
          sessionStorage.setItem('clickedVideoUrlHQ', videoUrl.replace('-sqt','-o'));
          sessionStorage.setItem('clickedVideoUrl', videoUrl);
          sessionStorage.setItem('clickedPreviewUrl', previewUrl);
          this.openPopup(videoUrl);
      });
  }
}

customElements.define("pdp-discovery", pdpDiscovery);



class discoverySticky extends HTMLElement{
  constructor() {
	  super();
    this.element = this;
	  this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
	  this.bindEvents();

	}

  bindEvents(){
    this.delegateElement.on("click", "[data-action=close-sticky]", this.hidePopup.bind(this));
  }

  hidePopup(){
    const popupElement = this.element.querySelector('.discovery-sticky');
    popupElement.style.display = 'none';
  }
}
customElements.define("discovery-sticky", discoverySticky)